// extracted by mini-css-extract-plugin
export default {"container":"ResetPrompt_container__rQz48"};